import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const MiniDownArrowIcon = withSvgIcon(
    <g>
        <polygon points="119,168 249,293.2 379,168 398.4,186.7 249,330.6 99.6,186.6     " />
    </g>
);
